import { Activity, useState } from 'react';
import { useNavigate } from 'react-router';

import SvgArrowRight from '@/assets/icons/ArrowRight';
import Plus from '@/assets/icons/Plus';
import { Button } from '@/components/UI/Button/Button';

import EenhedenUitsluitenDialog from './EenhedenUitsluitenDialog';
import useGetWtsEenheden from './useGetWtsEenheden';
import WtsTable from './WtsTable';

import styles from './WtsView.module.css';
const WtsView = () => {
  const navigate = useNavigate();
  useGetWtsEenheden();
  const [showDialog, setShowDialog] = useState<boolean>(false);
  return (
    <>
      <div className={styles.wtsContainer}>
        <div className={styles.wtsHeader}>
          <button onClick={() => navigate('/beheer')} className={styles.wtsNavbutton}>
            <div className={styles.wtsNav}>
              <SvgArrowRight
                width='24px'
                height='24px'
                style={{ transform: 'rotate(180deg)', fill: 'var(--tractie-color-content-emphasis)' }}
              />
              <h1 className={styles.wtsH1}>Eenheden uitgesloten van WTS</h1>
            </div>
          </button>
          <div>
            <Button data-testid={'uitsluitingToevoegenButton'} variant='primary' onClick={() => setShowDialog(true)}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <Plus width={24} height={24} fill='currentColor' />
                Uitsluiting toevoegen
              </div>
            </Button>
          </div>
        </div>
        <WtsTable />
      </div>
      <Activity mode={showDialog ? 'visible' : 'hidden'}>
        <EenhedenUitsluitenDialog showDialog={showDialog} handleOpenChange={setShowDialog} />
      </Activity>
    </>
  );
};
export default WtsView;
